import { TextField } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import {
    filterLabelByKey,
    renderUnitAdvancedByKeyAndType,
    validateTextField
} from '../../../handler/VersionListHandler';
import Constant from '@/common/constant/Constant';
import I18n from '@/rI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function AdvanceSetting({ 
    value,
    setValue,
    advancedOptionSettings,
    knowledgeService,
    internalQACounterSettings,
    deskService,
    setIsEdit,
    ...props 
}) {
    useTranslationSubscription();

    const handleInputChange = (advanceSettingValue, field, edittingKey, e, optionData) => {
        setIsEdit(true);
        //clear error
        const isQuantity = edittingKey === 'quantity';
        let otherKey = isQuantity ? 'price' : 'quantity';
        let inputValue = e.target.value;

        const otherKeyOfError = advanceSettingValue[field][otherKey].error;
        if (Utils.isEmptyString(inputValue) && otherKeyOfError === I18n.get('COMMSG014')) {
            setValue(prev => ({
                ...prev,
                [field]: {
                    ...prev[field],
                    [otherKey]: {
                        ...prev[field][otherKey],
                        error: ''
                    }
                }
            }));
        }

        //check value and clear error
        setValue((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [edittingKey]: {
                    ...prev[field][edittingKey],
                    value: inputValue,
                    error: '',
                },
            },
        }));

    };

    const handleOnBlur = (advanceSettingValue, field, edittingKey, e, optionData) => {
        
        let isQuantity = edittingKey === 'quantity';
        let otherKey = isQuantity ? 'price' : 'quantity';
        const blurValue = e.target.value.trim();

        const otherKeyOfValue = advanceSettingValue[field][otherKey].value;
        const otherKeyOfError = advanceSettingValue[field][otherKey].error;
        if (
            !Utils.isEmptyString(otherKeyOfValue) &&
            Utils.isEmptyString(otherKeyOfError) &&
            Utils.isEmptyString(blurValue)
        ) {
            setValue(prev => ({
                ...prev,
                [field]: {
                    ...prev[field],
                    [edittingKey]: {
                        ...prev[field][edittingKey],
                        error: I18n.get('COMMSG014')
                    }
                }
            }));
            return;
        }

        const edittingFieldOfRules = advanceSettingValue[field][edittingKey].rules
        const checkErrorValueInput = validateTextField(edittingFieldOfRules, blurValue, field);
        setValue((prev) => ({
            ...prev,
            [field]: {
                ...prev[field],
                [edittingKey]: {
                    ...prev[field][edittingKey],
                    value: blurValue,
                    error: checkErrorValueInput,
                },
            },
        }));
    };

    const handleDisabled = (item) => {
        if (item === Constant.SETTING_VERSION_LABEL.NUMBER_OF_ADDITIONAL_EX_WEB_API) {
            return false;
        }

        if (!advancedOptionSettings) {
            return true;
        }

        const isKnowledgeItem =
            item === Constant.SETTING_VERSION_LABEL.NUMBER_OF_ADDITIONAL_KNOWLEDGE && !knowledgeService;

        const deskRelatedItems = [
            Constant.SETTING_VERSION_LABEL.NUMBER_OF_ADDITIONAL_QA_COUNTER,
            Constant.SETTING_VERSION_LABEL.NUMBER_OF_ADDITIONAL_SUPPORTED_COUNTER,
        ];
        const isDeskItem = deskRelatedItems.includes(item) && !deskService;

        return isKnowledgeItem || isDeskItem;
    };

    return (
        <>
            <div className="setting-description border-bottom">
                <span className="description-detail col-5">{tr('追加項目')}</span>
                <span className="description-detail col-5">{tr('セット')}</span>
            </div>
            {Object.entries(value).map((field, index) => {
                // comment for now
                if (field[0] === Constant.SETTING_VERSION_LABEL.NUMBER_OF_ADDITIONAL_EX_WEB_API) {
                    return <></>
                }
                return (
                    <div className="setting-item border-bottom" key={index}>
                    <label className="setting-label col-5">{tr(filterLabelByKey(field[0]))}</label>
                    <div className="setting-action col-5">
                        {Object.entries(field[1]).map((option, i) => {
                            return (
                                <span key={i} className="option-container">
                                    <TextField
                                        className="form-control-input form-control-wrapInput form-control-hg32 setting-inputs"
                                        variant="outlined"
                                        spellCheck={false}
                                        disabled={handleDisabled(field[0])}
                                        type={'text'}
                                        value={option[1].value}
                                        onFocus={e => e.preventDefault()}
                                        onChange={e => handleInputChange(value, field[0], option[0], e, option[1])}
                                        onBlur={e => handleOnBlur(value, field[0], option[0], e, option[1])}
                                        onWheel={e => e.target.blur()}
                                        helperText={tr(option[1].error)}
                                        error={!Utils.isEmptyString(option[1].error)}
                                    />
                                    <label className="setting-unit">{tr(renderUnitAdvancedByKeyAndType(option[0], option[1].type))}</label>
                                </span>
                            );
                        })}
                    </div>
                </div>
                )
            })}
        </>
    );
}

export default AdvanceSetting;
